import DT from 'duration-time-conversion';
import { parseTime } from '../../../shared/utils';
import copyTextToClipboard from '../../../helpers/copyTextToClipboard';

export default function copyOcr(ocr) {
  const data = ocr
    .reduce((acc, curr) => {
      const { text, segments } = curr;
      segments.forEach((segment) => {
        acc.push({
          text,
          startTime: segment.startTime,
          endTime: segment.endTime,
        });
      });
      return acc;
    }, [])
    .sort((a, b) => DT.t2d(a.startTime) - DT.t2d(b.startTime))
    .map((item) => {
      const startTimeSeconds = DT.t2d(item.startTime) + DT.t2d('00:00.100');
      const endTimeSeconds = DT.t2d(item.endTime) + DT.t2d('00:00.100');
      const timestamp = `(${parseTime(startTimeSeconds)} - ${parseTime(endTimeSeconds)}) `;
      return `${timestamp} ${item.text.replace(/\s+/g, ' ')}`;
    })
    .join('\n\n');
  copyTextToClipboard(data);
}
